import { GetTagsResponse, Params } from '../types';
import { baseClient } from './client/instance';

const path = 'tags';

export const getTags = async (params?: Params) => {
  const response = await baseClient.get<GetTagsResponse>(path, { params });
  return response.data;
};
